module.exports = ".second-line{line-height:1px}.active-step *{color:#55b1bd !important}\n"